/* GIST LIBRARY — premium storefront interactions (gx-*) */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Scroll reveals */
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.gx-reveal:not([data-gx-rev])');
    if (!('IntersectionObserver' in window) || reduced) {
      els.forEach(function (el) { el.classList.add('gx-in'); el.setAttribute('data-gx-rev', '1'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('gx-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { el.setAttribute('data-gx-rev', '1'); io.observe(el); });
  }

  /* Count-up stats */
  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-gx-count') || '0');
    var suffix = el.getAttribute('data-gx-suffix') || '';
    var prefix = el.getAttribute('data-gx-prefix') || '';
    if (reduced) { el.innerHTML = prefix + target + '<b>' + suffix + '</b>'; return; }
    var start = null, dur = 1400;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.innerHTML = prefix + Math.round(target * eased) + '<b>' + suffix + '</b>';
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function initCounters(root) {
    var els = (root || document).querySelectorAll('[data-gx-count]:not([data-gx-counted])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.setAttribute('data-gx-counted', '1'); animateCount(el); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animateCount(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { el.setAttribute('data-gx-counted', '1'); if (!reduced) { el.innerHTML = (el.getAttribute('data-gx-prefix')||'') + '0<b>' + (el.getAttribute('data-gx-suffix')||'') + '</b>'; } io.observe(el); });
  }

  /* Sticky subscribe bar */
  function initSticky(root) {
    var bar = (root || document).querySelector('.gx-sticky:not([data-gx-init])');
    if (!bar) return;
    bar.setAttribute('data-gx-init', '1');
    try { if (sessionStorage.getItem('gx-sticky-off') === '1') return; } catch (e) {}
    var threshold = Math.max(window.innerHeight * 1.1, 700);
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var nearBottom = window.scrollY + window.innerHeight > document.body.scrollHeight - 420;
        bar.classList.toggle('gx-show', window.scrollY > threshold && !nearBottom);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    var close = bar.querySelector('.gx-sticky__close');
    if (close) close.addEventListener('click', function () {
      bar.classList.remove('gx-show');
      try { sessionStorage.setItem('gx-sticky-off', '1'); } catch (e) {}
      window.removeEventListener('scroll', onScroll);
    });
  }

  /* FAQ: close siblings for an accordion feel */
  function initFaq(root) {
    (root || document).querySelectorAll('.gx-faq__list:not([data-gx-init])').forEach(function (list) {
      list.setAttribute('data-gx-init', '1');
      list.addEventListener('toggle', function (ev) {
        var d = ev.target;
        if (d.tagName === 'DETAILS' && d.open) {
          list.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
        }
      }, true);
    });
  }

  function initAll(root) { initReveals(root); initCounters(root); initSticky(root); initFaq(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else { initAll(document); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

/* ===== GIST — MAX LAYER (interactions) · appended, additive, dependency-free.
   Co-exists with the IIFE above: never re-runs reveals or count-up. Motion-rich
   bits gated on a fine pointer + motion-OK. New elements use the gxm- namespace. ===== */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var body = document.body;

    /* 1 - Scroll distillation progress line. */
    var bar = document.createElement('div');
    bar.className = 'gxm-progress';
    bar.setAttribute('aria-hidden', 'true');
    body.appendChild(bar);

    var cssScroll = window.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()');
    if (!cssScroll || reduce) {
      var ticking = false;
      var setP = function () {
        var el = document.documentElement;
        var max = el.scrollHeight - el.clientHeight;
        var p = max > 0 ? (window.pageYOffset || el.scrollTop) / max : 0;
        bar.style.setProperty('--gxm-p', (p < 0 ? 0 : p > 1 ? 1 : p).toFixed(4));
        ticking = false;
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { window.requestAnimationFrame(setP); ticking = true; }
      }, { passive: true });
      window.addEventListener('resize', setP, { passive: true });
      setP();
    }

    /* 2 - Film grain (skip under reduced motion). */
    if (!reduce) {
      var grain = document.createElement('div');
      grain.className = 'gxm-grain';
      grain.setAttribute('aria-hidden', 'true');
      body.appendChild(grain);
    }

    /* 3 - Clickable scroll cue -> smooth-scroll past the hero. */
    var cue = document.querySelector('.gx-hero__scroll');
    var hero = document.querySelector('.gx-hero');
    if (cue && hero) {
      cue.setAttribute('role', 'button');
      cue.setAttribute('tabindex', '0');
      cue.setAttribute('aria-label', 'Scroll to content');
      var jump = function () {
        var host = hero.closest('.shopify-section') || hero;
        var target = host.nextElementSibling || hero.nextElementSibling;
        if (target && target.scrollIntoView) {
          target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        }
      };
      cue.addEventListener('click', jump);
      cue.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); jump(); }
      });
    }

    if (reduce || !fine) return;

    /* 4 - Cursor-reactive hero spotlight. */
    if (hero) {
      var spot = document.createElement('div');
      spot.className = 'gxm-spot';
      spot.setAttribute('aria-hidden', 'true');
      hero.insertBefore(spot, hero.firstChild);
      hero.addEventListener('pointermove', function (ev) {
        var r = hero.getBoundingClientRect();
        hero.style.setProperty('--gxm-x', (((ev.clientX - r.left) / r.width) * 100).toFixed(2) + '%');
        hero.style.setProperty('--gxm-y', (((ev.clientY - r.top) / r.height) * 100).toFixed(2) + '%');
      }, { passive: true });
      hero.addEventListener('pointerenter', function () { hero.classList.add('gxm-spot-on'); });
      hero.addEventListener('pointerleave', function () { hero.classList.remove('gxm-spot-on'); });
    }

    /* 5 - 3-D tilt on cards (max 4 deg), via CSS vars consumed only on :hover. */
    var MAX = 4;
    var cards = document.querySelectorAll('.gx-vcard, .gx-tcard, .gx-step');
    Array.prototype.forEach.call(cards, function (card) {
      card.addEventListener('pointermove', function (ev) {
        var r = card.getBoundingClientRect();
        var px = (ev.clientX - r.left) / r.width - 0.5;
        var py = (ev.clientY - r.top) / r.height - 0.5;
        card.classList.add('gxm-tilt');
        card.style.setProperty('--gxm-ry', (px * MAX).toFixed(2) + 'deg');
        card.style.setProperty('--gxm-rx', (-py * MAX).toFixed(2) + 'deg');
      }, { passive: true });
      card.addEventListener('pointerleave', function () {
        card.classList.remove('gxm-tilt');
        card.style.setProperty('--gxm-rx', '0deg');
        card.style.setProperty('--gxm-ry', '0deg');
      });
    });
  });
})();
